export default __webpack_public_path__ + "static/SR USA - Hoja de Seguridad - Color Caramelo (Liquido)-c3f3e66f47a1d7756b7689d1cdd4d676.pdf";